import { getEntityByName } from '../appEntities';
import { createSelector } from 'reselect';
import {
    get,
    isEqual
} from 'lodash';
import {
    REFUND_FAILURE,
    REFUND_LOAD,
    REFUND_SUCCESS
} from './refundActions';

export default function reducer(state = {}, action = {}) {
    let newState;

    switch (action.type) {
        case REFUND_LOAD:
            newState = {
                ...state,
                refunds: {
                    ...state.refunds,
                    [action.id]: {
                        error: null,
                        loading: true,
                        success: false
                    }
                }
            };

            return isEqual(state, newState) ? state : newState;

        case REFUND_SUCCESS:
            newState = {
                ...state,
                refunds: {
                    ...state.refunds,
                    [action.id]: {
                        error: null,
                        loading: false,
                        success: true
                    }
                }
            };

            return isEqual(state, newState) ? state : newState;

        case REFUND_FAILURE: {
            const currentRefund = get(state, `refunds.${action.id}`, {});

            newState = {
                ...state,
                refunds: {
                    ...state.refunds,
                    [action.id]: {
                        error: action.error,
                        loading: false,
                        success: currentRefund.success
                    }
                }
            };

            return isEqual(state, newState) ? state : newState;
        }

        default:
            return state;
    }
}

export const getRefundEntity = createSelector(
    (state) => (state),
    (state) => getEntityByName(state, 'refund')
);

export const getRefunds = createSelector(
    getRefundEntity,
    (entity) => get(entity, 'refunds')
);

export const getRefundObjectById = createSelector(
    getRefunds,
    (state, id) => id,
    (refunds, id = '') => get(refunds, id)
);

export const getIsRefundLoadingById = createSelector(
    (state, id) => getRefundObjectById(state, id),
    (refundObject) => get(refundObject, 'loading')
);

export const getIsRefundSuccessfulById = createSelector(
    (state, id) => getRefundObjectById(state, id),
    (refundObject) => get(refundObject, 'success')
);

export const getRefundErrorById = createSelector(
    (state, id) => getRefundObjectById(state, id),
    (refundObject) => get(refundObject, 'error')
);

export const getRefundErrorMessageById = createSelector(
    (state, id) => getRefundErrorById(state, id),
    (error) => get(error, 'message')
);
